import React, { useEffect, useState } from "react";
import "../assets/Coundown.css";

const Countdown = () => {
  const calculateTimeLeft = () => {
    // 🎯 Target time: 16 Nov 2025 at 12:00 AM (midnight, Cambodia time)
    const eventDate = new Date("2025-11-16T00:00:00+07:00");
    const now = new Date();
    const difference = eventDate - now;

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      // ⏹️ Stop when countdown hits 0
      if (
        newTimeLeft.days === 0 &&
        newTimeLeft.hours === 0 &&
        newTimeLeft.minutes === 0 &&
        newTimeLeft.seconds === 0
      ) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="countdown-container">
      <h6 className="countdown-title">រាប់ថយក្រោយទៅដល់ថ្ងៃកម្មវិធី</h6>

      <div className="countdown-boxes">
        <div className="countdown-item">
          {timeLeft.days}
          <div className="countdown-label">ថ្ងៃ</div>
        </div>

        <div className="countdown-item">
          {timeLeft.hours}
          <div className="countdown-label">ម៉ោង</div>
        </div>

        <div className="countdown-item">
          {timeLeft.minutes}
          <div className="countdown-label">នាទី</div>
        </div>

      </div>
    </div>
  );
};

export default Countdown;
